/**
 * Sidebar profile content — the fixed "about" anchor of the site.
 * Edit this file to update the name, role, bio, education, or links shown
 * in the sidebar. This never changes based on the active gallery category.
 */

export interface ProfileLink {
  label: string;
  href: string;
  icon: 'github' | 'linkedin' | 'email';
}

export interface EducationEntry {
  degree: string;
  institution: string;
  period: string;
}

export interface AboutMeContent {
  paragraphs: string[];
  paragraphSpacing?: string;
}

export const profile = {
  name: 'Kyle Webster',
  role: "Computational Mathematician,\n Rendering Researcher,\n Average Design Enjoyer",
  /** Path to a profile photo (e.g. 'profile.jpg', copied to dist/ alongside index.html). Leave undefined to keep the gradient avatar. */
  avatarSrc: undefined as string | undefined,
  /** Path to a larger profile photo shown beside the "About Me" section. Leave undefined to keep the gradient placeholder. */
  aboutPhotoSrc: "photos/20250725_153942.jpg",
  bio:
    "I build physically-based simulations from the ground up. Now, I'm pursuing an M.S. in Computer Science at the University of Utah, researching light transport methods with the Realistic Computer Graphics group.",
  /** Longer bio shown in the 'About' gallery panel's "About Me" section. Separate from the short sidebar `bio`. */
  aboutMe: {
    paragraphs: [
      "Hello internet! My name is Kyle, I'm a computational mathematician developing technical models across light transport, computational electromagnetics, fluid mechanics, and data analysis. I've built and adapted partial differential equation codes as research assistants at the University of British Columbia and the University of Utah; I also worked at Enbridge, creating and presenting a binary classifier and dashboard for capital expenditures.",
      "Currently, I'm studying at the University of Utah for a Master's of Science in Computer Science while researching light transport algorithms with the Realistic Computer Graphics group. When I'm not writing code you'll find me road running, doing film photography, or improving my DotA 2 rank (99.95th percentile in North America).",
    ],
    paragraphSpacing: '1rem',
  } as AboutMeContent,
  education: [
    { degree: 'M.S. Computer Science', institution: 'University of Utah', period: 'anticipated 2027' },
    { degree: 'B.Sc. Integrated Science', institution: 'University of British Columbia', period: '2025' },
    { degree: 'B.Sc. Mathematics', institution: 'University of British Columbia', period: '2022' },
  ] as EducationEntry[],
  links: [
    { label: 'GitHub', href: 'https://github.com/webstek', icon: 'github' },
    { label: 'LinkedIn', href: 'https://linkedin.com/in/kyle-webster-91a101245/', icon: 'linkedin' },
  ] as ProfileLink[],
};
